import { Component } from '@angular/core';
import { TeamActionMockSettingsService } from './team-action-mock-settings.service';

// Maquette d'estimation « action d'équipe » : interrupteur qui montre ou masque les pastilles « Nouveau ».
@Component({
  selector: 'team-action-mock-new-toggle',
  template: `<mat-slide-toggle color="primary" [checked]="settings.showNew" (change)="settings.setShowNew($event.checked)">
    Repérer les nouveautés
  </mat-slide-toggle>`,
})
export class TeamActionMockNewToggleComponent {
  constructor(public settings: TeamActionMockSettingsService) {}
}
